import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Instagram, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { title: 'Home', path: '/' },
    { title: 'About', path: '/about' },
    { title: 'Products & Services', path: '/products-services' },
    { title: 'Careers', path: '/careers' },
    { title: 'News', path: '/news' },
  ];

  return (
    <footer className="bg-vincotek-dark text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img 
                src="/assets/Logo%20Vincotek%20Pty%20Ltd-Icon%20White.png" 
                alt="Vincotek Logo" 
                className="h-8 w-auto"
              />
              <span className="text-2xl font-bold">Vincotek</span>
            </div>
            <p className="text-gray-300 leading-relaxed">
              Empowering Technology. Enabling Growth.
            </p>
            <p className="text-sm text-gray-400">
              Building digital solutions that make life and work easier for everyone.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-vincotek-yellow">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-vincotek-blue transition-colors duration-200"
                  >
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-vincotek-yellow">Services</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Web Development</li>
              <li>App Development</li>
              <li>IT Consulting</li>
              <li>Digital Solutions</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-vincotek-yellow">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-2 text-gray-300">
                <Mail className="h-4 w-4" />
                <span className="text-sm">info@vincotek.com</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300">
                <Phone className="h-4 w-4" />
                <span className="text-sm">+61 (08) 123 456 789</span>
              </div>
              <div className="flex items-center space-x-4 pt-2">
                <Instagram className="h-5 w-5 text-gray-300 hover:text-vincotek-yellow cursor-pointer transition-colors" />
                <Linkedin className="h-5 w-5 text-gray-300 hover:text-vincotek-blue cursor-pointer transition-colors" />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-700 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400">
              © {currentYear} Vincotek Pty Ltd. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/privacy" className="text-sm text-gray-400 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-sm text-gray-400 hover:text-white transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;